import {useSearch} from '@aboutyou/router';
import {SSOParams} from './constants';

export const useIsAuthenticatingLegacyApple = () => {
  const search = useSearch();
  const params = new URLSearchParams(search);
  const code = params.get(SSOParams.Code);
  const sso = params.get(SSOParams.SSO);

  return !!code && !!sso;
};
